// -*-mode: rjsx -*-
// REACT
import React, { useState, useEffect } from "react"
// eslint-disable-next-line
import clsx from "clsx"
// UTILS
// eslint-disable-next-line
import * as _ from "lodash"
// eslint-disable-next-line
import tinycolor from "tinycolor2"

// MUI
import { makeStyles, withStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Paper from "@material-ui/core/Paper"
import UncheckedCircle from "@material-ui/icons/RadioButtonUnchecked"
import CheckedCircle from "@material-ui/icons/Done"
import Checkbox from "@material-ui/core/Checkbox"
import TextField from "@material-ui/core/TextField"
import SvgIcon from "@material-ui/core/SvgIcon"

// COLORS
// eslint-disable-next-line
import lime from "@material-ui/core/colors/lime"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"

// FLASH
// eslint-disable-next-line
import { globalStyles, useGlobalStyles } from "../FlashStyles.js"
import FlashItem from "../Flash/FlashItem.js"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashSelectCard>")

const useDefaultStyles = makeStyles(theme => ({
    root: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        width: "100%",
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
        //        maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            // marginTop: 15,
            width: "100%",
            borderRadius: 6,
        },
        
    },

    checkedCircle: {
//        ...theme.css.checkedCircle,
        fontSize: 38,
    },

    checkedCircleFilled: {
        ...theme.css.checkedCircleFilled,
        fontSize: 50,
    },
    

    uncheckedCircle: {
        ...theme.css.uncheckedCircle,
        fontSize: 50,
    },


    
    backgroundCircle: {
        color: grey[700],
        fontSize: 50,
    },

    yourReasonTextField: {
        marginLeft: 20,
        marginRight: 20,
        // width: 480,
        width: "100%",
        zIndex: 0,
        color: theme.palette.primary.contrastText,
        //        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            //            backgroundColor: theme.palette.primary.light,
        },

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            // width: 280,
        },

    },

    yourReasonFont:{
        fontSize: 18,
    },

    

}), { name: "FlashSelectCard" })


const CssTextField = withStyles(theme => ({
    root: {
        '& label.Mui-focused': {
            color: theme.palette.primary.main,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: theme.palette.primary.light,
        },
        '& .MuiInput-underline:after fieldset': {
            //          borderWidth: 4,
        },
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderColor: theme.palette.primary.light,
                //          borderWidth: 4,
            },
            '&.Mui-focused fieldset': {
                borderColor: theme.palette.primary.main,
            },
            '& fieldset': {
                // borderRadius: 0
                borderWidth: 2, // NEXt continue here, but only make border bigger on focus
                borderColor: grey[500],
            },
            
        },
    },
}))(TextField)


let FlashSelectCard = (props) => {

    // eslint-disable-next-line
    const { children, style, text, className,
            // eslint-disable-next-line
            hasMore = true,
            // eslint-disable-next-line
            hasLess = true,
            // eslint-disable-next-line
            clickBody = false,
            onRankClick,
            onCustomChange,
            //            isChecked = false,
            statement,
          } = props

    const classes = {
        ...useDefaultStyles(),
        ...className,
    }

    // DEBUG only
    // eslint-disable-next-line
    const [isDebugLayout, setDebugLayout] = useState(false)
    //    const [yourReason, setYourReason] = useState({
    //        txt: "",
    //        isChecked: false,
    //        rank: 0,
    //    })

    useEffect(() => {
        // console.log("<FlashSelectCard>: we have an effect running")
    })

    log.trace("inside the body, text =", text)

    return (
        <Paper className={classes.root}>

          { !statement.isYourReason &&
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <FlashItem
                clickBody={true}
                expanded={true}
                hasMore={false}
                hasLess={false}  
              >
                <Typography variant="subtitle2" style={{marginLeft: 20, fontSize: 18, fontWeight: 400 }}>
                  {text}
                </Typography>

              </FlashItem>
              <Checkbox
                icon={
                    <div style={{position: "relative"}}>
                      <div>
                        <UncheckedCircle className={classes.uncheckedCircle}/>
                      </div>
                    </div>
                }
                checkedIcon={
                    <div style={{position: "relative"}}>
                      <div>
                        <SvgIcon viewBox="0 0 24 24" className={classes.backgroundCircle}>
                          <circle cx="12" cy="12" r="12" stroke="none" fill={grey[700]} />
                        </SvgIcon>
                      </div>

                      <div style={{
                          position: "absolute",
                          left: "50%",
                          top: "50%",
                          transform: "translate(-50%,-50%)",
                          //                          backgroundColor: grey[500],
                      }}>
                    {/*
                        <Typography style={{fontSize: 30, color: grey[100], marginBottom: 8, fontWeight: "bold"}}>
                          {statement.rank}
                        </Typography>
                     */}
                        <CheckedCircle className={classes.checkedCircle}/>
                      </div>                    
                    </div>
                }
            //                onChange={onRankClick}
//                onChange={() => {log.debug("im changed")}}
//                onClick={() => {log.debug("im clicked")}}
                checked={statement.isChecked ? statement.isChecked : false}
                onClick={onRankClick}
              />
            </div>
          }

          { statement.isYourReason &&
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>

              <CssTextField
                className={classes.yourReasonTextField}
                InputProps={{
                    classes: {
                        input: classes.yourReasonFont
                    }
                }}

                label="my other reason"
                InputLabelProps={{shrink: true}}
                placeholder="my other reason (100 characters)"
                type="text"
                name="yourreason"
                autoComplete="none"
                margin="dense"
                variant="outlined"
                value={statement.txt}
                onChange={onCustomChange}
              >
              </CssTextField>

              <Checkbox
                icon={
                    <div style={{position: "relative"}}>
                      <div>
                        <UncheckedCircle className={classes.uncheckedCircle}/>
                      </div>
                    </div>
                }
                checkedIcon={
                    <div style={{position: "relative"}}>
                      <div>
                        <SvgIcon viewBox="0 0 24 24" className={classes.backgroundCircle}>
                          <circle cx="12" cy="12" r="12" stroke="none" fill={grey[700]} />
                        </SvgIcon>
                      </div>

                      <div style={{
                          position: "absolute",
                          left: "50%",
                          top: "50%",
                          transform: "translate(-50%,-50%)",
                          //                          backgroundColor: grey[500],
                      }}>
                    {/*
                        <Typography style={{fontSize: 30, color: grey[100], marginBottom: 8, fontWeight: "bold"}}>
                          {statement.rank}
                        </Typography>
                     */}
                        <CheckedCircle className={classes.checkedCircle}/>
                      </div>                    
                    </div>
                }
                // was not clicking on when it was on Change
            // onChange={onRankClick}
                onClick={onRankClick}
                checked={statement.isChecked ? statement.isChecked : false}
              />
              
            </div>
          }
          
        </Paper>
    )
}

export default FlashSelectCard
